export default __webpack_public_path__ + "7ef6bdf966e6db834bc74ed4ef436a58.png";